import type { EraId } from '../config/eras';

/**
 * One-off changes to the calendar, at the user's request. On 7 and 8 October 2026 the two days swap circuits
 * (the layout, its name and its region, the scenery as it was), each keeping its own car, physics and medals;
 * and 7 October races the 2022 in place of the rotation's 2004.
 */
const CIRCUIT_SWAPS: Readonly<Record<string, string>> = { '2026-10-07': '2026-10-08', '2026-10-08': '2026-10-07' };
const CAR_CHANGES: Readonly<Record<string, EraId>> = { '2026-10-07': '2022' };

/** The date whose circuit a day races: its own, unless the calendar swapped it. */
export function circuitDate(date: string): string {
  return CIRCUIT_SWAPS[date] ?? date;
}

/** The car a day races in place of the rotation's, if the calendar changed it. */
export function carChange(date: string): EraId | undefined {
  return CAR_CHANGES[date];
}
